import { render, staticRenderFns } from "./OrderAddressEdit.vue?vue&type=template&id=bb917bcc&scoped=true&"
import script from "./OrderAddressEdit.vue?vue&type=script&lang=js&"
export * from "./OrderAddressEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddressEdit.vue?vue&type=style&index=0&id=bb917bcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb917bcc",
  null
  
)

export default component.exports